<script setup>
import {onMounted, onUnmounted, reactive, ref} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  payPeriodId: Number
});

const data = reactive({
  holdbacksAlreadyGenerated: [],
  holdbacksToBeGenerated: [],
  loading: false,
  generatedHoldbacks: 0,
  success: false
});

const getAlreadyGeneratedData = () => {
  data.loading=true;
  ApiWrapper
      .get('holdbacks', 'get-already-generated-holdbacks-for-pay-period', 'payPeriodId='+props.payPeriodId)
      .then((response) => {
        if(response.holdbacksAlreadyGenerated){
          data.holdbacksAlreadyGenerated = response.holdbacksAlreadyGenerated
        }
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        data.loading = false;
      });
};

const getHoldbacksToBeGeneratedData = () => {
  data.loading=true;
  ApiWrapper
      .get('holdbacks', 'get-new-holdbacks-for-pay-period', 'payPeriodId='+props.payPeriodId)
      .then((response) => {
        if(response.newHoldbacksToBeCreated){
          data.holdbacksToBeGenerated = response.newHoldbacksToBeCreated
        }
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        data.loading = false;
      });
};

const generateNewHoldbacks = () => {
  data.loading=true;
  ApiWrapper
      .post('holdbacks', 'generate-new-holdbacks-for-pay-period', {payPeriodId: props.payPeriodId})
      .then((response) => {
        if(response.generatedHoldbacks){
          data.generatedHoldbacks = response.generatedHoldbacks;
        }
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        data.loading = false;
        if(data.generatedHoldbacks>0){
          ToastUtil.successMsg(`Holdbacks generated!`);

          data.success = true;
          getAlreadyGeneratedData();
          getHoldbacksToBeGeneratedData();
        }
        else{
          ToastUtil.errorMsg('No holdbacks were generated. Please check the holdback data for this pay period.');
        }
      });
}

onMounted(()=>{
  getAlreadyGeneratedData();
  getHoldbacksToBeGeneratedData();
})

</script>

<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Generate New Holdbacks for Pay Period {{props.payPeriodId}}</v-card-title>
      <v-card-item>
        <v-card>
          <v-card-subtitle>Already Generated: {{data.holdbacksAlreadyGenerated.length}}</v-card-subtitle>
          <v-card-item>
            <v-data-table
                :items="data.holdbacksAlreadyGenerated"
                :loading="data.loading"
            >

            </v-data-table>
          </v-card-item>
          <v-card-subtitle>To Be Generated: {{data.holdbacksToBeGenerated.length}}</v-card-subtitle>
          <v-card-item>
            <v-data-table
                :items="data.holdbacksToBeGenerated"
                :loading="data.loading"
            >
            </v-data-table>
          </v-card-item>
          <v-card-item v-if="!data.success && data.holdbacksToBeGenerated.length>1">
            <v-btn
                color="primary"
                block
                class="mt-5 mb-5"
                variant="elevated"
                :loading="data.loading"
                :disabled="data.holdbacksToBeGenerated.length === 0"
                @click="generateNewHoldbacks"
            >
              Generate New Holdbacks
            </v-btn>
          </v-card-item>
        </v-card>
        <v-card v-if="data.success">
          <v-card-title>
            Holdbacks Successfully Generated!
          </v-card-title>
          <v-card-subtitle>
            <RouterLink :to="'/payperiod/'+props.payPeriodId">
              <v-btn
                  color="primary"
                  variant="elevated"
                  class="mt-3 mb-3"
              >
                Return to Pay Period View
              </v-btn>
            </RouterLink>
          </v-card-subtitle>
        </v-card>
      </v-card-item>
    </v-card>

  </v-container>
</template>

<style scoped>

</style>